import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import Hidden from "@mui/material/Hidden";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Salesman from "./Salesmans";
import ViewSalesmanInformation from "./ViewSalesmanInformation";
import { useHistory, useLocation } from "react-router-dom";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
}));

function SalesmansMain(props) {
  const history = useHistory();
  const { search } = useLocation();
  const classes = useStyles();
  const theme = useTheme();
  const [viewing, setViewing] = useState();
  const [showAccountInformation, setShowAccountInformation] = useState(false);
  const [accountAction, setAccountAction] = useState("add");
  const [selectedAccount, setSelectedAccount] = useState();

  function viewPricingClickListener() {
    history.push({
      pathname: "/manageAccountAndPricing",
      search: `?viewing=pricing`,
    });
  }

  const accountOnClickListener = (account) => (event) => {
    setSelectedAccount(account);
    setShowAccountInformation(true);
  };

  const editAccountClickListener = (event) => {
    setAccountAction("edit");
    alert();
  };

  useEffect(() => {
    const viewing = new URLSearchParams(search).get("viewing");
    setViewing(viewing);
  });

  return (
    <div>
      <Salesman
        handleDrawerToggle={props.handleDrawerToggle}
        accountAction={accountAction}
        viewPricingClickListener={viewPricingClickListener}
        accountOnClickListener={accountOnClickListener}
      />
      <ViewSalesmanInformation
        selectedAccount={selectedAccount}
        editAccountClickListener={editAccountClickListener}
        showAccountInformation={showAccountInformation}
        setShowAccountInformation={setShowAccountInformation}
      ></ViewSalesmanInformation>
    </div>
  );
}

export default SalesmansMain;
